import { ASSIGNED_SPACE_DETAILS_ACTION } from 'core/constants/Actions'
import { Action } from 'core/models/ActionTypes'
import { Space } from 'core/models/Space';

const initialState: { space: Space | null, isLoading: boolean } = {
  space: null,
  isLoading: false
}

interface ActionType extends Action {
  payload: {
    space: Space;
  }
}

export default function spaceDetailsReducer(state = initialState, action: ActionType) {

  switch (action.type) {
    case ASSIGNED_SPACE_DETAILS_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case ASSIGNED_SPACE_DETAILS_ACTION.SUCCESS:
      const { space } = action.payload;
      return { ...state, space, isLoading: false }

    case ASSIGNED_SPACE_DETAILS_ACTION.FAILURE:
      return { ...state, ...initialState }

    default:
      return state
  }
}